import React from "react";
import { Button } from "baseui/button";
import { Input } from "baseui/input";

const List = ({ value, onChange, placeholder = "Item", onBlur=()=>{} }) => {
  if(typeof(value) == 'string') {
    onChange([value])
    setTimeout(() => onBlur(), 1000)
    return <></>
  }
  
  return (
    <div>
      {value.map((v, i) => (
        <div class='mb-2'>
          <Input
            value={v}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={(e) => {
              const arr = [...value];
              arr[i] = e.target.value;
              onChange(arr);
            }}
          />
        </div>
      ))}
      <div class='mt-2'>
        <Button onClick={() => onChange([...value, ""])}>Add</Button>
      </div>
    </div>
  );
};

export default List;
